import {  Component, Input } from '@angular/core';
import { FlightOffer } from '@app/models/offerpack/FlightOffer';

@Component({
    selector: 'clever-flight-mini-detail',
    templateUrl: './flight-mini-detail.component.html',
    styleUrls: ['./flight-mini-detail.component.scss'],
    standalone: false
})
export class FlightMiniDetailComponent {
    @Input() datas: FlightOffer;
    constructor() { }
}
